import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { useSettings } from "./../context/SettingsContext";
const DineInRoute = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const tableId = searchParams.get("table");
  const hasRun = useRef(false);
  const { settings } = useSettings(); 
  const [showTablePopup, setShowTablePopup] = useState(false);
  const [tables, setTables] = useState([]);
  const [loadingTables, setLoadingTables] = useState(false);
  const [selectedTableId, setSelectedTableId] = useState("");

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    if (tableId === "masterqr") {
      fetchTables();
      setShowTablePopup(true);
      return;
    }

    verifyTable(tableId);
  }, [tableId]);

  useEffect(() => {
  const handlePageShow = (event) => {
    if (event.persisted) {
      window.location.reload();
    }
  };

  window.addEventListener("pageshow", handlePageShow);

  return () => {
    window.removeEventListener("pageshow", handlePageShow);
  };
}, []);

  const fetchTables = async () => {
    try {
      setLoadingTables(true);
      // const res = await axios.get(
      //   `https://fosv2.foodship.net/api/fos/dinein/tablelist`
      // );

      const res = await axios.get(
        `${window.location.protocol}//${window.location.hostname}/dinein/tablelist`
      );

      if (res.data?.success) {
        setTables(res.data.data || []);
      } else {
        toast.error("Failed to load tables");
      }
    } catch (err) {
      console.error(err);
      toast.error("Unable to fetch tables");
    } finally {
      setLoadingTables(false);
    }
  };

  const verifyTable = async (tableId) => {
    if (!tableId) {
      toast.error("Invalid table link");
      navigate("/");
      return;
    }

    try {
      const res = await axios.get(
        `${window.BASE_API_URL}verifyTable/${tableId}`
      );

      if (res.data?.success) {
        setupDineIn(res.data.data);
      } else {
        toast.error("Invalid or inactive table");
        redirectToMenu();
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to verify table");
      redirectToMenu();
    }
  };

const setupDineIn = (tableData) => {


  let timer = parseInt(settings?.dinein_timer_in_minute, 10);


  // If column missing, null, invalid, or NaN → use 90
  if (isNaN(timer) || timer <= 0) {
    timer = 90;
  }

  // Preserve settings before clear
  localStorage.clear();

  const expiresAt = Date.now() + timer * 60 * 1000;

  localStorage.setItem(
    "dinein",
    JSON.stringify({
      apptype: "dinein",
      tableId: tableData.id,
      tableName: tableData.name,
      expiresAt,
    })
  );

  localStorage.setItem("apptype", "dinein");
  localStorage.setItem("tableId", tableData.id);
  localStorage.setItem("tableName", tableData.name);

  toast.success(`Welcome to ${tableData.name}!`);
  redirectToMenu();
};

  const redirectToMenu = () => {
    setTimeout(() => {
      window.location.href = "/menu-app/dinein-app";
    }, 1000);
  };

  const handleContinue = () => {
    const table = tables.find(
      (t) => t.id.toString() === selectedTableId
    );

    if (!table) {
      toast.error("Please select a table");
      return;
    }

    setupDineIn(table);
  };

  return (
    <>
      <div className="flex items-center justify-center h-screen text-lg font-medium">
        Verifying your table...
      </div>

      {/* 🔹 TABLE SELECTION POPUP */}
      {showTablePopup && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-[90%] max-w-md">
            <h2 className="text-xl font-semibold mb-4 text-center">
              Select Your Table
            </h2>

            {loadingTables ? (
              <p className="text-center">Loading tables...</p>
            ) : (
              <>
                <select
                  value={selectedTableId}
                  onChange={(e) => setSelectedTableId(e.target.value)}
                  className="w-full border rounded-lg p-3 mb-4 focus:outline-none focus:ring-2 focus:ring-orange-400"
                >
                  <option value="">-- Select Table --</option>
                  {tables.map((table) => (
                    <option key={table.id} value={table.id}>
                      {table.name}
                    </option>
                  ))}
                </select>

                <button
                  onClick={handleContinue}
                  disabled={!selectedTableId}
                  className={`w-full py-3 rounded-lg font-medium text-white transition
                    ${
                      selectedTableId
                        ? "bg-orange-500 hover:bg-orange-600"
                        : "bg-gray-300 cursor-not-allowed"
                    }`}
                >
                  Continue
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default DineInRoute;
